import React from "react";
import MPriceWidget2 from "Components/mobile/activity/MPriceWidget2";
import defaultProductPic from "Images/default-brand.jpg";
import SCIcon from "Components/common/SCIcon";
import { CRDEditTrigger } from "Components/order/OrderPreviewCRDModal";
export interface ProductCardProps {
  orderProduct: {
    sku: number | string;
    productSize?: string;
    productName: string;
    pdpViewable?: boolean;
    productPic?: string;
    description?: string;
    listPrice?: number | string;
    priceStatus?: string;
    shoppingQty?: number;
    finalPrice?: number | string;
    level1Qty?: number;
    level1Price?: string;
    level2Qty?: number;
    level2Price?: number | string;
    crd?: string;
    CRD_Range?: any;
    lineNumber?: string | number;
  };
  cartData?: Object;
  previewData?: Object;
  isOrderPreviewFlag?: true,
  activityId?: number | string;
  activityStartTime?: string;
  contactUs?: () => void;
  enableCRD?: boolean;
  onEditCRD?: (product: any) => void;
}

const MOrderProductCard: React.FC<ProductCardProps> = (props: any) => {
  const { orderProduct, contactUs, cartData, previewData, enableCRD, onEditCRD } = props;
  const { product } = orderProduct

  return (
    <div className={'cartProduct'}>
      <div className={'productContainer'}>
        <div className={'catalogDetails'}>
          <label className={'catalog'} style={{ marginBottom: "0" }}>
            {orderProduct.sku}
          </label>
          <div style={{ display: "flex" }}>{product.deliveryChannel === "SC" && <SCIcon />}</div>
        </div>
        <div className={'subProductContainer'}>
          <div className={'productImage'}>
            {!!product.productPic ? (
              <img
              alt=""
                style={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                }}
                src={product.productPic}
              />
            ) : (
              <img
              alt=""
                style={{
                  width: "80px",
                  height: "80px",
                }}
                src={defaultProductPic}
              />
            )}
          </div>
          <div className={'productDetails'}>
            <label
              id={'productName'}
              dangerouslySetInnerHTML={{
                __html: product.productName,
              }}
            ></label>
            <div className={'wopContainer'}>
              <MPriceWidget2
                product={product}
                contactUs={contactUs}
                cartData={cartData}
                previewData={previewData}
                isOrderPreviewFlag={true}
                size="small"
              />
              <label className={'quantity'}>X{orderProduct.quantity}</label>
            </div>
            {enableCRD && orderProduct.CRD_Range?.status === "eligible" && (
              <div className="crdRow">
                <span className="crdLabel">期望发货日期</span>
                <CRDEditTrigger
                  value={orderProduct.crd}
                  mobile={true}
                  onClick={() => onEditCRD?.(orderProduct)}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MOrderProductCard;
